// extracted by mini-css-extract-plugin
export default {"cell":"Loader_cell__E0byz"};